/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadRiskMinimalDto
 */
export interface ReadRiskMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ReadRiskMinimalDto
     */
    riskId: string;
    /**
     * 
     * @type {string}
     * @memberof ReadRiskMinimalDto
     */
    folderIdentifier: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadRiskMinimalDto
     */
    creationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ReadRiskMinimalDto
     */
    label?: string;
}

/**
 * Check if a given object implements the ReadRiskMinimalDto interface.
 */
export function instanceOfReadRiskMinimalDto(value: object): value is ReadRiskMinimalDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('folderIdentifier' in value) || value['folderIdentifier'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function ReadRiskMinimalDtoFromJSON(json: any): ReadRiskMinimalDto {
    return ReadRiskMinimalDtoFromJSONTyped(json, false);
}

export function ReadRiskMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadRiskMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'folderIdentifier': json['folderIdentifier'],
        'creationDate': (new Date(json['creationDate'])),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ReadRiskMinimalDtoToJSON(json: any): ReadRiskMinimalDto {
    return ReadRiskMinimalDtoToJSONTyped(json, false);
}

export function ReadRiskMinimalDtoToJSONTyped(value?: ReadRiskMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'folderIdentifier': value['folderIdentifier'],
        'creationDate': ((value['creationDate']).toISOString().substring(0,10)),
        'label': value['label'],
    };
}

